import { useState } from "react";
import { Input } from "antd";

export default function FloatInput(props) {
	const {
		label,
		placeholder,
		value,
		id,
		className,
		required,
		autoComplete = "off",
		size = "middle",
		...rest
	} = props;

	const [focus, setFocus] = useState(false);

	let new_placeholder = !placeholder ? label : placeholder;

	let isOccupied = focus || (value && value !== "" && value.length !== 0);

	let labelClass =
		isOccupied || (value && value === "0" && value.length !== 0)
			? "label float-label"
			: "label";

	let requiredMark = required ? <span className="text-danger">*</span> : null;

	return (
		<div
			id={id ?? ""}
			className={`float-wrapper ${className ? className : ""}`}
			onBlur={() => setFocus(false)}
			onFocus={() => setFocus(true)}
		>
			<Input value={value} autoComplete={autoComplete} size={size} {...rest} />
			<label className={labelClass}>
				{isOccupied ? label : new_placeholder} {requiredMark}
			</label>
		</div>
	);
}
